import React, {useState, useRef, useEffect} from 'react';
import {gql} from "apollo-boost";
import client from '../../src/graphql/client';
import {get, uniqBy, flatMap} from 'lodash';
import styled from 'styled-components';
import {Grid, Box} from '@material-ui/core';
import {useForm} from "react-hook-form";
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Router from 'next/router';
import ReactHtmlParser from 'react-html-parser';
import produce from 'immer';
import qs from 'qs';

import Topo from '../../src/assets/topo-block-blue.png'
import Button from '../../src/components/ui/Cta';
import Text from '../../src/components/typography';
import {theme} from '../../src/themes/default-theme';
import getSavedPostcode from '../../src/util/getSavedPostcode';
import {filterOverlayProps} from '../../src/data-restructure/ui/model-overlay';

import seoQuery from '../../src/graphql/queries/seo';
import respImgQuery from '../../src/graphql/queries/resp-img';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../src/data-restructure/multimedia/hero-banner-carousel';
import refactorBookAViewing from '../../src/data-restructure/pages/book-a-viewing'
import refactorDealerDropdowns from '../../src/data-restructure/pages/book-a-viewing/dealer'
import refactorOverlayProps from '../../src/data-restructure/ui/model-overlay'
import {sellsMotorhomes, sellsCampervans} from '../../src/util/filterDealerMotorHomes';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import TabSelect from '../../src/components/forms/TabSelect';
import ModelSelectModal from '../../src/components/ui/ModelSelectModal';

// steps
import Step1 from '../../src/containers/Forms/BookAViewing/Steps/Step1';
import Step2 from '../../src/containers/Forms/BookAViewing/Steps/Step2';
import Step3 from '../../src/containers/Forms/BookAViewing/Steps/Step3';
// import Step4 from '../../src/containers/Forms/BookAViewing/Steps/Step4';
import Step4 from '../../src/containers/Forms/BookAViewing/Steps/Step5';

import step1Svg from '../../src/assets/icons/viewing-form-icon-1.svg';
import step2Svg from '../../src/assets/icons/viewing-form-icon-2.svg';
import step3Svg from '../../src/assets/icons/viewing-form-icon-3.svg';
// import step4Svg from '../../src/assets/icons/viewing-form-icon-4.svg';
import step4Svg from '../../src/assets/icons/viewing-form-icon-5.svg';
import jaycoClient from '../../src/graphql/stockClient';


const Wrapper = styled.div`

`

const IntroContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 780px;
  margin-top: 40px;
  margin-bottom: 35px;

  ${theme.breakpoints.up('md')} {
    margin-top: 80px;
    margin-bottom: 50px;
  }

  ${theme.breakpoints.up('md')} {
    margin-top: 115px;
  }

`

const FormWrapper = styled.div `
  background: ${theme.palette.skyGradientLight};
  padding: 20px 16px;
  position: relative;

  ${theme.breakpoints.up('md')} {
    padding: 110px 15px;

    &:before {
      content: ' ';
      display: block;
      width: 345px;
      height: 224px;
      background-image: url(${Topo});
      position: absolute;
      background-size: 100% auto;
      left: 0;
      right: 0;
      margin: auto;
      z-index: -1;
      top: 50px;
      transform: translateX(-190px);
    }
  }
`

const Container = styled.div`
  background-color: ${theme.palette.white};
  max-width: 820px;
  margin: 0 auto;
  padding: 20px 16px;
  border-bottom-left-radius: 30px;

  ${theme.breakpoints.up('md')} {
    padding: 52px 58px;
    border-bottom-left-radius: 60px;
  }
`

const Form = styled.form`
  text-align: left;
`

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `30px 0`};

`

const Footer = styled.div`
 
  ${props => props.borderTop === 1 && `
     border-top: 1px solid ${theme.palette.middleGrey};
  `
  }
  
  ${props => props.marginTop === 1 && `
    margin-top: 30px;
  `
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form};
  ${props => props.alignCenter && `
    text-align: center;
  `}
`

const ButtonContainer = styled.div`
  margin-left: 10px;
  display: inline-block;
  margin-bottom: 10px;
`

const IconContainer = styled.div`
  margin: 35px auto 35px;

  ${theme.breakpoints.up('md')} {
    margin-top: 80px;
    margin-bottom: 50px;
  }
`

const Step = styled.div `
  ${props => !props.show && `
    display: none;
  `}
  ${props => props.disabled && `
    opacity: 0.5;
  `}
}`

const BookAViewing = (props) => {
  
  const countryCode = props.countryProps.countryCode
  const country = countryCode === 'AU' ? "Australia's" : "New Zealand's";
  const [dealers, setDealers] = useState(props.dealers);

  const [sending, setSending] = useState(false);
  
  const [error, setError] = useState(null);
  const [captchaError, setCaptchaError] = useState(null);
  const [step, setStep] = useState(1);
  const [stepsValid, setStepsValid] = useState({});
  const [dealersSelect, setDealersSelect] = useState([]);
  const [dealerSummary, setDealerSummary] = useState([]);
  const [modelError, setModelError] = useState(null);
  const [loading, setLoading] = useState(null);
  const [modelDropdowns, setModelDropdowns] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [modal, setModal] = useState(false);
  const [rangeOverlayProps, setRangeOverlayProps] = useState((props.overlayProps))

  const showStock = !process.env.DEALER_SITE  || (process.env.DEALER_SITE && get(props, 'router.query.stock', false)) === false ? false : true

  // const defaultInterestState = {
  //   range: undefined,
  //   series: undefined,
  //   model: undefined
  // }

  const [modelsOfInterest, setModelsOfInterest] = useState([])


  useEffect(() => {
    const qsData = qs.parse(window.location.search.replace('?',''));

    if (qsData && qsData.items) {
      const items = qsData.items.map(qsItem => {
        const rangeProp = rangeOverlayProps.find(item => item.title.toLowerCase() === qsItem.range.toLowerCase());
        const seriesProp = rangeProp && rangeProp.models ? rangeProp.models.find(item => item.seriesTitle.toLowerCase() === qsItem.series.toLowerCase()) : null;
        const modelProp = seriesProp && seriesProp.models ? seriesProp.models.find(model => model.title.toLowerCase() === qsItem.model.toLowerCase()) : null;
        return {
          ...modelProp
        }
      }).filter(item => {
        return item.id ? true : false
      });
      console.log('items', qsData, items, rangeOverlayProps);
      setModelsOfInterest(items);
    }
  }, [])

  useEffect(() => {
    if (modelError) {
      var valid = true;
      for(var i = 0; i < modelsOfInterest.length; i++) {
        var item = modelsOfInterest[i];
        if (item.range === undefined || item.series  === undefined) {
        // if (item.range === undefined || item.series  === undefined || item.model  === undefined) {
          valid = false;
          break;
        }
      }
      setModelError(!valid);
    }

    // console.log('check here...', modelsOfInterest);

    
    let motorhomes = false
    let campervans = false

    modelsOfInterest.forEach(item => {
      if (item.rangeTitle && (item.rangeTitle.toLowerCase() === 'motorhomes')) {
        motorhomes = true
      }
      if (item.rangeTitle.toLowerCase() === 'campervans') {
        campervans = true
      }

    });

    console.log('modelsOfInterest', {modelsOfInterest, motorhomes, campervans, dealers: props.dealers});

    const newDealerState = props.dealers.filter(item => {
      if (motorhomes && get(item, 'acf_dealers.motorhomes', '0') !== '1') {
        return false;
      }

      if (campervans && get(item, 'acf_dealers.campervans', '0') !== '1' && (item.title && item.title.toLowerCase() !== 'jayco canberra')) {
        return false;
      }

      return true
    })

    if (newDealerState.length !== dealers.length) {
      setDealers(newDealerState)
    }

  }, [modelsOfInterest])

  useEffect(() => {
    if (!process.env.DEALER_SITE) {
      setStep2FormState({
        postcode: dealers.length > 0 ? getSavedPostcode() : undefined,
      });
      setDealersSelect([]);
      setDealerSummary([]);
      setStepsValid({
        ...stepsValid,
        2: false
      })
    }
  },[dealers]);

  //const handleInterestchange = (index, type, val) => {
  const handleInterestchange = (index, val) => {
    const nextState = produce(modelsOfInterest, draftState => {
      draftState[index] = val
    })
    setModelsOfInterest(nextState);
  }

  const handleAddModel = (model) => {
    const defaultModel = get(model, 'models[0]', model)
    const nextState = produce(modelsOfInterest, draftState => {
      draftState.push(defaultModel)
    })
    setModelsOfInterest(nextState)
    setModal(false)
  }

  const handleRemoveModel = (index) => {
    const nextState = produce(modelsOfInterest, draftState => {
      draftState.splice(index, 1);
    })
    setModelsOfInterest(nextState);
  }

  const [tabSelectState, setTabSelectState] = useState([
    {
      icon: step1Svg,
      tick: false,
      id: 1,
    },
    {
      icon: step2Svg,
      tick: false,
      id: process.env.DEALER_SITE ? null : 2,
    },
    {
      icon: step3Svg,
      tick: false,
      id: 3,
    },
    {
      icon: step4Svg,
      tick: false,
      id: 4,
    }
  ])

  const handleTabChange = async (val) => {

    if (step === 1 && modelsOfInterest.length === 0) {
      return;
    }

    await handleNext(false);

    // If moving forward
    if (val + 1 && stepsValid[step] === true) {
      setStep(val + 1);
    }

    // If moving back
    if (stepsValid[val + 1] === true) {
      setStep(val + 1);
    }
  }

  useEffect(() => {
    // const model = get(props, 'router.query.model', null);
    const getData = async (dealerId) => {
      // if (!model) {

        setLoading(true)
        
        const GET_UBS_DATA = gql`
          query GetUBSStockForDealer {
            getDealer(id: "${dealerId}") {
              name
              ubsStock(limit: 1000) {
                items {
                  id
                  make
                  model
                  series
                  stockNumber
                  variant
                  images
                }
              }
            }
          }
        `

        const result = await jaycoClient.query({
          query: GET_UBS_DATA
        }) || {};

        const stock = get(result, 'data.getDealer.ubsStock.items', null)
        // const models = stock.map(item => {
        //   return {
        //     id: item.id,
        //     value: item.model,
        //     text: item.model,
        //   }
        // })

        // const data = uniqBy(models, 'value');
        const data = refactorDealerDropdowns(stock);

        if (data && data.ranges) {
          setModelDropdowns(data);
          setRangeOverlayProps(data.ranges);
        } else {
          console.log('error', error)
        }
        setApiError(null);
        setLoading(false);

      // }
    }

    if (!showStock) {
      return;
    }

    const windowDealerId = process.env.DEALER_SITE && window.staticly.dealerData.id.indexOf('{{') === -1 ? window.staticly.dealerData.id : null
    const dealerId = windowDealerId ? windowDealerId : get(props, 'router.query.dealerid', null);

    if (dealerId && process.env.DEALER_SITE) {
      getData(dealerId);
    } else {
      setLoading(false);
      setApiError('Something went wrong. Please try again later.');
    }

  }, [props.router.query]);

  useEffect(() => {
    const newTabSelectState = tabSelectState.map((tab, index) => {
      const tick = stepsValid[index + 1] === true ? true : false
      return {
        ...tab,
        tick: tick
      }
    })
    setTabSelectState(newTabSelectState);
  }, [stepsValid]);

  useEffect(()=> {
    setGoogleCaptcha(null);
    if (step === 5) {
      const invalidStep = tabSelectState.find(item => item.tick === false);
      if (invalidStep && invalidStep.id !== 5 && invalidStep.id !== 4) {
        setStep(invalidStep.id);
      }
    }

  }, [step])

  const [step1FormState, setStep1FormState] = useState({});
  const [step2FormState, setStep2FormState] = useState({
    postcode: process.browser ? getSavedPostcode() : null,
  });
  const [step3FormState, setStep3FormState] = useState({});
  // const [step4FormState, setStep4FormState] = useState({});
  const [step4FormState, setStep4FormState] = useState({
    newsletter: false,
    privacy: false
  });

  const step1FormProps = useForm();
  const step2FormProps = useForm();
  const step3FormProps = useForm();
  // const step4FormProps = useForm();
  const step4FormProps = useForm();

  const [googleCaptcha, setGoogleCaptcha] = useState(false);

  const onSubmit = async data => {

    const recaptchaValue = recaptchaRef.current.getValue();

    const dealerId = process.env.DEALER_SITE && window.staticly.dealerData.id ? {
      dealer: window.staticly.dealerData.id
    } : {}

    const formData = {
      ...data,
      'g-recaptcha-response': googleCaptcha,
      // ...step1FormState,
      models: modelsOfInterest.map(item => {
        return {
          range: item.rangeTitle,
          series: item.seriesTitle,
          model: item.title
        }
      }),
      ...step2FormState,
      ...step3FormState,
      // ...step4FormState,
      form_id: 'book_a_viewing',
      ...dealerId
    }

    if (googleCaptcha && recaptchaValue.length > 0 && Object.keys(step3FormProps.errors).length === 0) {
      let formattedData = {};
      let bodyFormData = new FormData();

      Object.keys(formData).forEach(key => {

        if (typeof formData[key] === 'object' && formData[key] && formData[key].value) {
          // For dropdowns
          const value = formData[key].value.toString();
          formattedData[key] = formData[key].value.toString() || ''
          bodyFormData.set(key, value);
          //console.log('dd', formData[key]);
        } else if (typeof formData[key] === 'object' && formData[key] && (!formData[key].value || formData[key].length > 0)) {
        // } else if (typeof formData[key] === 'object' && !get(formData, `[${key}].value`, null) && formData[key] &&formData[key].length > 0) {
          // For models
          formattedData[key] = [];
          for(var i = 0; i < formData[key].length; i++){
            let item = formData[key][i];
            bodyFormData.append('model[' + i + ']', JSON.stringify(item));
            formattedData[key].push(item);
          }
        } else {
          // For all others
          //console.log('other', formData[key]);
          formattedData[key] = formData[key] ? formData[key].toString() : '';
          bodyFormData.append(key, formData[key] ? formData[key].toString() : '');
        }
      });

      setCaptchaError(null);

      const endpoint = props.formAction ? props.formAction : process.env.STATICLY_FORMS_API_ENDPOINT;

      setSending(true);
      const thankyou = '/book-a-viewing/thank-you'
      
      axios({
        method: 'post',
        url: endpoint,
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        console.log('response:', response);
        process.env.NODE_ENV === 'development' ?
          window.location.href = thankyou
        :
        Router.push(thankyou);
      })
      .catch((error) => {
        console.log('Form error: ', error);
        setSending(false);
        setError('Something went wrong. Please try again later.')
      });

    } else {
      setCaptchaError('Google captcha not complete');
      setSending(false)
    }
  }

  const handleNext = async (moveToStep) => {
    
    if (step === 1) {
      // var valid = true;
      // for(var i = 0; i < modelsOfInterest.length; i++) {
      //   var item = modelsOfInterest[i];
      //   if (item.range === undefined || item.series  === undefined ) {
      //   // if (item.range === undefined || item.series  === undefined || item.model  === undefined) {
      //     valid = false;
      //     break;
      //   }
      // }
      const valid = modelsOfInterest.length > 0 ? true : false;
      console.log(valid);
      if (valid) {
        moveToStep !== false && setStep(process.env.DEALER_SITE ? 3 : 2);
        setModelError(false)
        setStepsValid({
          ...stepsValid,
          1: true
        })
      } else {
        setModelError(true)
        setStepsValid({
          ...stepsValid,
          1: false
        })
      }
    }

    if (step === 2) {
      await step2FormProps.triggerValidation();
      setStep2FormState(step2FormProps.getValues());
      if (Object.keys(step2FormProps.errors).length === 0) {
        moveToStep !== false && setStep(3);
        setStepsValid({
          ...stepsValid,
          2: true
        })
      } else {
        setStepsValid({
          ...stepsValid,
          2: false
        })
      }
    }
    if (step === 3) {
      await step3FormProps.triggerValidation();
      setStep3FormState(step3FormProps.getValues());
      if (Object.keys(step3FormProps.errors).length === 0) {
        moveToStep !== false && setStep(4);
        setStepsValid({
          ...stepsValid,
          3: true
        })
      } else {
        setStepsValid({
          ...stepsValid,
          3: false
        })
      }
    }

    handleScroll();
    
  }

  const handleChange = async () => {
    if (step === 1) {
      if (Object.keys(step1FormProps.errors).length > 0) {
        await step1FormProps.triggerValidation();
      }
      setStep1FormState(step1FormProps.getValues());
    }
    if (step === 2) {
      if (Object.keys(step2FormProps.errors).length > 0) {
        await step2FormProps.triggerValidation();
      }
      setStep2FormState(step2FormProps.getValues());
    }
    if (step === 3) {
      if (Object.keys(step3FormProps.errors).length > 0) {
        await step3FormProps.triggerValidation();
      }
      setStep3FormState(step3FormProps.getValues());
    }
    if (step === 4) {
      if (Object.keys(step4FormProps.errors).length > 0) {
        await step4FormProps.triggerValidation();
      }
      setStep4FormState(step4FormProps.getValues());
    }
  }

  const setDefaultDealer = (dealer) => {
    step2FormProps.setValue('dealer', dealer)
  }

  const setDealersSelectItems = (items) => {
    setDealersSelect(uniqBy(items, 'value'));
  }

  const handlePrev = () => {
    if (process.env.DEALER_SITE && step === 3) {
      setStep(step - 2);
    } else {
      setStep(step - 1);
    }
    handleScroll();
  }

  const handleScroll = () => {
    const { top } = containerRef.current.getBoundingClientRect();
    const position = top + window.pageYOffset
    position ? window.scrollTo({
      top: position,
      behavior: 'smooth'
    }) : containerRef.current.scrollIntoView({ behavior: 'smooth'});
  }

  const handleSetDealerSummary = (dealer) => {

    const contact = {
      addressLine1: get(dealer, 'acf_dealers.addressLine1', null),
      addressLine2: get(dealer, 'acf_dealers.addressLine2', null),
      phone: get(dealer, 'acf_dealers.phone', null),
      suburb: get(dealer, 'acf_dealers.suburb', null), 
      state: get(dealer, 'acf_dealers.state', ''),
      postcode: get(dealer, 'acf_dealers.postcode', ''),
    }

    let addressArr = [];
    contact.addressLine1 && addressArr.push(contact.addressLine1);
    contact.addressLine2 && addressArr.push(contact.addressLine2);
    contact.suburb && addressArr.push(contact.suburb);
    contact.state || contact.postcode && addressArr.push(contact.state ? `${contact.state} ` : '' ` ${contact.postcode ? contact.postcode : ''}`);

    const address = addressArr.join(', ')

    setDealerSummary({
      name: get(dealer, 'title', null),
      address: address,
      phone: contact.phone
    })
  }

  const recaptchaRef = useRef();
  const activeIndex = (process.env.DEALER_SITE && step > 2) ? (step - 1) : step;



  const containerRef = useRef();

  const filteredRangeOverlayProps = filterOverlayProps(rangeOverlayProps, modelsOfInterest);


  const ranges = process.env.DEALER_SITE ? filteredRangeOverlayProps.map(range => {
    const _sellsCampervans = sellsCampervans();
    const _sellsMotorhomes = sellsMotorhomes();

    const models = range.models.filter(item => {

      if (item.title.toLowerCase().indexOf('campervan') !== -1 && !_sellsCampervans ) {
        return false
      }
      if (item.title.toLowerCase().indexOf('motorhome') !== -1 && !_sellsMotorhomes ) {
        return false
      }

      return true;
    });

    return {
      ...range,
      models
    }

  }).filter(item => {
    return item.models.length > 0
  }) : filteredRangeOverlayProps

  console.log('RANGES', ranges)

  
  // console.log('rangeOverlayProps new', filteredRangeOverlayProps);

  return (
    <>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }
      <ModelSelectModal 
        open={modal}
        onSelect={(model) => handleAddModel(model)}
        handleModal={setModal}
        ranges={ranges}
      />
  	<Wrapper>

      {!process.env.DEALER_SITE &&
        <IntroContainer>
          <Grid container direction={'row'} justify={'space-between'} align={'center'}>
            <Grid item xs={12}>
              <Box px={2}>
                <Text variant="body1" align="center">
                  <p>Whether you're new to caravanning or an avid adventurer, we can help make the journey to your next great escape easy, enjoyable and stress-free.</p>
                  <p>Book an obligation-free inspection with one of our dealerships today to view our wide range of new and used Jayco caravans and motorhomes.</p>
                </Text>
              </Box>
            </Grid>
          </Grid>
        </IntroContainer>
      }

      <IconContainer ref={containerRef}>
        <TabSelect
          data={tabSelectState.filter(item => item.id !== null)}
          activeIndex={activeIndex - 1}
          onChange={handleTabChange}
        />
      </IconContainer>

      <FormWrapper>
        <Container>
          {apiError ?
            <Error alignCenter={true}>{apiError}</Error>
          :
            <Form id="book_a_service" noValidate autoComplete="off" onChange={handleChange}>
                
                {/* default val in step 1 select & react hook forms aren't working so hiding step 1 for now */}
                <Step show={step === 1  ? true : false} disabled={loading}>
                  <Text variant="h4" uppercase colour="charcoal" align="center">Model of Interest</Text>
                  <Step1
                    formProps={step1FormProps} 
                    onFormChange={handleChange}
                    state={step1FormState} 
                    // ranges={modelDropdowns ? modelDropdowns.ranges : ranges}
                    ranges={rangeOverlayProps}
                    modelsOfInterest={modelsOfInterest}
                    onChange={handleInterestchange}
                    onAddModel={() => setModal(true)}
                    onRemoveModel={handleRemoveModel}
                    error={modelError}
                    showModelDropdown={!showStock}
                  />
                </Step>

                {step === 2 &&
                  <>
                    <Text variant="h4" uppercase colour="charcoal" align="center">Select Dealer</Text>
                    <Step2 
                      formProps={step2FormProps} 
                      onFormChange={handleChange} 
                      state={step2FormState}
                      countryCode={countryCode} 
                      dealers={dealers}
                      setDefaultDealer={setDefaultDealer} 
                      setDealersSelect={setDealersSelectItems}
                      dealersSelect={dealersSelect}
                      setDealerSummary={handleSetDealerSummary}
                    />
                  </>
                }

                {step === 3 &&
                  <>
                    <Text variant="h4" uppercase colour="charcoal" align="center">Your details</Text>
                    <Step3 
                      formProps={step3FormProps} 
                      onFormChange={handleChange} 
                      state={step3FormState}
                    />
                  </>
                }
                {
                  step === 4 &&
                  <>
                    <Text variant="h4" uppercase colour="charcoal" align="center">Summary</Text>
                    <br />
                    <Text variant="body1" align="center">Your summary is below. Once you submit your request a sales representative will be in contact to confirm you booking details.</Text>
      
                    <Step4 
                      formProps={step4FormProps}
                      onFormChange={handleChange}
                      state={step4FormState}
                      country={country}
                      setStep={(step) => setStep(step)}
                      showSeries={!showStock}
                      summary={{
                        step1: modelsOfInterest,
                        dealerSummary: process.env.DEALER_SITE ? null : dealerSummary,
                        step2: step2FormState,
                        step3: step3FormState,
                      }}
                    />
                    <FormItem>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
                        onChange={setGoogleCaptcha}
                      />
                      {!googleCaptcha && captchaError &&
                        <Error>{captchaError}</Error>
                      }
                      {error &&
                        <Error>{error}</Error>
                      }
                    </FormItem>
                  </>
                }
                <Footer marginTop={step === 1 ? 1 : 0 } borderTop={(step === 1 && modelsOfInterest.length === 3) ? 0 : 1 }>
                  <FormItem>
                    <Grid container direction={'row'} justify={'space-between'} align={'center'}>
                      <Grid item xs={2}>
                        <Text variant="body2">Mandatory*</Text>
                      </Grid>
                      <Grid item xs={10} align={'right'}>
                        {step !== 1 &&
                          <ButtonContainer>
                            <Button inline outline secondary onClick={handlePrev}>Previous</Button>
                          </ButtonContainer>
                        }
                        {step !== (tabSelectState.length) ?
                          <ButtonContainer>
                            <Button inline onClick={handleNext} disabled={loading}>Next</Button>
                          </ButtonContainer>
                          :
                          <ButtonContainer>
                            <Button inline onClick={step4FormProps.handleSubmit(onSubmit)}>{sending ? 'Submitting...'  : 'Submit'}</Button>
                          </ButtonContainer>
                        }
                      </Grid>
                    </Grid>
                  </FormItem>
                </Footer>
            </Form>
          }
        </Container>
        
      </FormWrapper>
      
    </Wrapper>
    </>
  )
}
  
BookAViewing.propTypes = {

}

BookAViewing.defaultProps = {

}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;

  const GET_CB_DATA = gql`
    query GET_CB_DATA {
      pageBy(uri: "book-a-viewing?${countryCode.toLowerCase()}") {
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery()}
        acf_domains {
          assignedDomains
        }
      }
      dealers(first: 1000) {
        nodes {
          title
          acf_dealers {
            addressLine1
            addressLine2
            phone
            sales
            country
            dealerID
            state
            latitude
            longitude
            postcode
            postcodes
            motorhomes
            campervans
          }
        }
      }
      ranges(first: 10000) {
        nodes {
          title
          id
          rangeId
          acf_range {
            rangeSeriesRef {
              ... on Series {
                id
                title
                acf_series {
                  seriesImage {
                    altText
                    mediaDetails {
                      sizes {
                        width
                        sourceUrl
                        name
                        height
                      }
                    }
                  }
                  seriesSpecsRep {
                    id
                    seriesSpecRepTitle
                  }
                }
              }
            }
          }
        }
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          id
          title
          acf_floor_plan {
            seriesSpec
            modelLayoutId
            modelLayoutName
            modelExternalImagesRep {
              modelExternalImagesRepImage {
                ${respImgQuery}
              }
            }
            modelSeries {
              ... on Series {
                id
              }
            }
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_CB_DATA,
  });

  const context = get(result, 'data.pageBy', {});
  const dealers = get(result, 'data.dealers.nodes', []);
  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;

  // Banner carousel
  const hasCarousel = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(cbData[0]) : null;

  const country = countryCode === 'AU' ? "Australia" : "New Zealand";

  const assignedDomains = get(result, 'data.pageBy.acf_domains.assignedDomains', []); 

  const getDealersByCountry = (dealers) => {
    return dealers ? dealers.filter(dealer => {
      // return get(dealer, 'acf_dealers.country', '') === country
      return (get(dealer, 'acf_dealers.country', '') === country) && get(dealer, 'acf_dealers.sales', '') === '1'

    }).map(dealer => {
      return {
        ...dealer,
        title: ReactHtmlParser(dealer.title)[0].toString() // title(format: RAW) is returning null so use this work around
      }
    }) : []
  }

  const props = refactorBookAViewing(result);

  return {
    props: {
      meta: {
        title: context.title,
        seo: context.seo,
        assignedDomains
      },
      breadcrumbs: await refactorBreadcrumbsData('/book-a-viewing', assignedDomains),
      dealers: getDealersByCountry(dealers),
      heroBanner,
      heroBannerCarousel,
      country,
      countryCode,
      overlayProps: refactorOverlayProps(props.ranges)
    }
  }
}

export default BookAViewing